import React, { useEffect, useState } from 'react';

const VendorRatings = () => {
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customerNames, setCustomerNames] = useState({});

  // Get vendor_id from logged in user
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const vendor_id = user.id;

  useEffect(() => {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer_ratings?vendor_id=${vendor_id}`)
      .then(res => res.json())
      .then(async data => {
        const ratingsArr = data.ratings || [];
        setRatings(ratingsArr);
        // Fetch customer names for each unique user_id (rater)
        const userIds = Array.from(new Set(ratingsArr.map(r => r.user_id).filter(Boolean)));
        const namesMap = {};
        await Promise.all(userIds.map(async (uid) => {
          try {
            const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer?customer_id=${uid}`);
            const data = await res.json();
            if (data.customer) {
              namesMap[uid] = `${data.customer.firstName || ''} ${data.customer.lastName || ''}`.trim();
            }
          } catch {
            namesMap[uid] = '';
          }
        }));
        setCustomerNames(namesMap);
        setLoading(false);
      })
      .catch(() => {
        setRatings([]);
        setLoading(false);
      });
  }, [vendor_id]);

  const renderStars = (rating) => {
    const stars = [];
    const maxStars = 5;
    for (let i = 1; i <= maxStars; i++) {
      stars.push(
        <span
          key={i}
          style={{
            color: i <= rating ? '#FFD700' : '#ccc',
            fontSize: '1.5rem',
            marginRight: '2px',
            textShadow: i <= rating ? '0 1px 4px #ffe082' : 'none',
          }}
        >
          ★
        </span>
      );
    }
    return <span>{stars}</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loader}>Loading ratings...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.iconCircle}>
          <i className="fas fa-star" style={styles.icon}></i>
        </span>
        <h2 style={styles.title}>Customer Ratings</h2>
        <p style={styles.subtitle}>
          See what your customers think about your service!
        </p>
      </div>
      {ratings.length === 0 ? (
        <div style={styles.empty}>No ratings yet.</div>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Customer Name</th>
              <th style={styles.th}>Rating</th>
              <th style={styles.th}>Comment</th>
              <th style={styles.th}>Date</th>
            </tr>
          </thead>
          <tbody>
            {ratings.map((rating, idx) => (
              <tr key={idx} style={styles.tr}>
                <td style={styles.td}>{customerNames[rating.user_id] || ''}</td>
                <td style={styles.td}>{renderStars(rating.rating)}</td>
                <td style={styles.tdComment}>{rating.comment}</td>
                <td style={styles.td}>{formatDate(rating.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '48px auto',
    padding: '40px',
    background: '#fff',
    borderRadius: '18px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  iconCircle: {
    background: '#FFD700',
    borderRadius: '50%',
    width: '54px',
    height: '54px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '12px',
    boxShadow: '0 2px 8px #ffe082',
  },
  icon: {
    color: '#fff',
    fontSize: '2rem',
    textShadow: '0 1px 4px #ffe082',
  },
  title: {
    color: '#4078c0',
    fontSize: '1.7rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    marginTop: '0',
  },
  subtitle: {
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '0',
    marginTop: '0',
  },
  loader: {
    textAlign: 'center',
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    padding: '40px 0',
  },
  empty: {
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    marginTop: '32px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '8px',
    background: '#f5f6fa',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 1px 8px rgba(64,120,192,0.07)',
  },
  th: {
    background: '#fffde4',
    color: '#8d6e36',
    padding: '12px',
    borderBottom: '2px solid #eee',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    textAlign: 'center',
  },
  tr: {
    background: '#fff',
    transition: 'background 0.2s',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    textAlign: 'center',
    fontSize: '1.08rem',
    color: '#4078c0',
    fontWeight: 'bold',
    background: '#fff',
  },
  tdComment: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    textAlign: 'left',
    fontSize: '1.08rem',
    color: '#555',
    background: '#fff',
    fontStyle: 'italic',
    borderRadius: '6px',
  },
};

export default VendorRatings;